@if ((planLevel == 'E' || planLevel == 'P') && addNewVisible) {
<!--<button mat-flat-button (click)="addNewFunc()" style="background-color:transparent;color:#000f70;border: 2px solid #000f70">
    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
    <span class="hidden sm:block ml-2 text-sm font-medium whitespace-nowrap select-none uppercase">{{addNewText}}</span>
</button>-->
<!--<button matMiniFab (click)="addNewFunc()">
    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
</button>
<button matFab aria-label="Example icon button with a delete icon">
    <mat-icon>delete</mat-icon>
</button>
<button matFab disabled aria-label="Example icon button with a heart icon">
    <mat-icon>favorite</mat-icon>
</button>-->

<!-- <div (click)="addNewFunc()"
     class="fixed flex items-center justify-center right-10 bottom-10 w-10 h-10 shadow-2xl ring-4 rounded-full z-90 cursor-pointer bg-[#00e6be] bg-opacity-100 print:hidden">
    <mat-icon class="icon-size-5 text-black" [svgIcon]="'heroicons_solid:plus'"></mat-icon>
</div> -->

<button mat-fab class="fixed right-[50px] bottom-[10px] md:right-[75px] z-90 rounded-full bg-[#00e6be] text-black" (click)="addNewFunc()">
  <mat-icon>add</mat-icon>
</button>

}
